import { Button } from 'primereact/button';

type HeaderTableProps = {
  enabled: any;
  setEnabled: any;
  onSync: () => void;
  syncing: boolean;
}

export const HeaderTable = (props: HeaderTableProps) => {
  return (
    <div className="table-header flex justify-between">
      <h5 className="mx-0 my-1">Descuentos</h5>
      <div>
        <Button
          icon={props.enabled ? "pi pi-eye" : "pi pi-eye-slash"}
          className="p-button-sm"
          label={props.enabled ? "Ver todos" : "Ocultar dehabilitados"}
          onClick={() => { props.setEnabled(!props.enabled); }}
        />
        <Button
          icon="pi pi-sync"
          label="Sincronizar desde SIS"
          className="p-button-info p-button-sm"
          loading={props.syncing}
          onClick={props.onSync}
        />
      </div>
    </div>
  );
}
